<template>
  <v-app id="inspire" class="login-page">
    <v-main>
      <v-container class="fill-height" fluid="fluid" style="padding: 0">
        <!-- <img src="@/assets/image/solar1.jpg" class="Drone_image"> -->
        <div class="main_font">
          <h4 class="drone_font">
            Drone
          </h4>
          <h3 class="drone_font1">
            X
          </h3>
          <h4 class="drone_font2">
            Ai
          </h4>
          <h4 class="solar_font">
            SOLAR PV Inspection
          </h4>
          <h4 class="metarpas_font">
            Power by MetaRPAS
          </h4>
        </div>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <img
                class="logo_image"
                src="@/assets/image/solvit_logo.png"
                alt=""
              >
              <!-- <v-toolbar color="primary" dark flat> <v-toolbar-title >KT 5G sUAS
                                    Management Platform</v-toolbar-title > <v-spacer></v-spacer> </v-toolbar> -->
              <!-- <v-card-text> -->
              <!-- <ValidationObserver ref="observer" v-slot="{ validate, reset }"> -->
              <ValidationObserver ref="observer" class="inputbox">
                <form>
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('login.userId')"
                    rules="required|max:10"
                  >
                    <v-text-field
                      id="focusid"
                      ref="cursor"
                      v-model="username"
                      color="text"
                      data-testid="username-input"
                      mode="lazy"
                      :error-messages="errors"
                      prepend-icon="mdi-account"
                      :label="$t('login.userId')"
                      style="width: 450px"
                      required="required"
                      :rules="loginRules"
                      @keydown.enter="submit"
                    />
                    <label
                      onclick="document.getElementById('username'.focus())"
                    />
                  </ValidationProvider>
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('login.password')"
                    rules="required|max:12"
                  >
                    <v-text-field
                      ref="cursor1"
                      v-model="password"
                      color="text"
                      data-testid="password-input"
                      mode="lazy"
                      :error-messages="errors"
                      :label="$t('login.password')"
                      prepend-icon="mdi-lock"
                      style="width: 450px"
                      :type="show1 ? 'text' : 'password'"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      required="required"
                      @keydown.enter="submit"
                      @click:append="show1 = !show1"
                    />
                  </ValidationProvider>
                  <!-- ValidationProvider form 유효성 검사 -->

                  <!-- <ValidationProvider v-slot="{ errors, valid }" rules="required"
                                            name="checkbox"> -->
                  <!-- <ValidationProvider v-slot="{ errors }" name="autoLogin"> <v-checkbox
                                            v-model="autoLogin" :error-messages="errors" value="Y" :label="$t('login.rememberMe')"
                                            type="checkbox" ></v-checkbox> </ValidationProvider> -->
                </form>
              </ValidationObserver>
              <!-- </v-card-text> -->
              <!-- <v-card-actions> -->
              <v-spacer />
              <p v-if="loginError" class="errmsg" data-testid="error-message">
                {{ loginErrorMsg }}
              </p>
              <v-btn
                class="login_btn"
                elevation="0"
                data-testid="login-button"
                style="height: 60px; width: 400px"
                @click="submit"
              >
                {{ $t('login.submit') }}
              </v-btn>
              <!-- </v-card-actions> -->
            </v-card>
          </v-col>
        </v-row>
        <div class="dcncaoper_img">
          <v-img :src="brandImageSrc" max-width="290" contain />
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { required, max } from 'vee-validate/dist/rules';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from 'vee-validate';
import { mapActions, mapGetters } from 'vuex';
import i18n from '@/plugins/i18n';
import { login as authLogin } from '@/auth';

setInteractionMode('lazy');
// 모든 인스턴스에 대해 상호 작용 모드를 설정
// 사용자가 입력을 떠날 때 트리거된다.(on lazy 또는 change)
extend('required', {
  ...required,
  message: (field) => i18n.t('validation.veeRequired', { field })
});

extend('max', {
  ...max,
  message: (field, values) =>
    i18n.t('validation.veeMax', { field, length: values.length })
});

export default {
  name: 'LoginPage',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      errmessage: false,
      errmessage1: false,
      show1: false,
      password: '',
      username: '',
      loginErrorMsg: undefined
    };
  },
  created() {
    // TODO:로그인을 위해 로컬스토리지에 저장된 토큰을 비워야 합니다.
    // localStorage.removeItem(`${토큰을 저장할 변수명}`)
  },
  computed: {
    loginRules() {
      return [
        (v) =>
          !/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g.test(v) || this.$t('login.asciiUsername')
      ];
    },
    ...mapGetters({ isLogined: 'user/isLogined' }),
    ...mapGetters({ loginError: 'user/getLoginError' }),
    // 환경 변수에 따라 브랜드 이미지 경로 결정
    brandImageSrc() {
      // VUE_APP_BRAND 환경 변수가 'solarwiz'인 경우 solarwiz.png 사용
      // 그 외의 경우 dcncaoper.png 사용 (기본값)
      const brand = process.env.VUE_APP_BRAND;
      return '';
      // return brand === 'solarwiz' 
      //   ? require('@/assets/solarwiz.png')
      //   : require('@/assets/dcncaoper.png');
    }
  },
  watch: {
    loginError(newVal) {
      if (newVal?.name) {
        if (newVal) {
          if (newVal.message.includes('401')) {
            this.loginErrorMsg = this.$t('login.credentialsInvalid');
          } else {
            this.loginErrorMsg = this.$t('login.serviceError');
          }
        }
      } else {
        this.loginErrorMsg = newVal;
      }
    }
  },
  async mounted() {
    // 컴포넌트 마운트 시 로그인 상태 확인
    if (this.isLogined) {
      await this.redirectToDashboard();
    }
  },
  methods: {
    async redirectToDashboard() {
      await this.resetAiDefectViewState();
      if (window.location.pathname !== '/dashboard') {
        await this.resetState();
        await this.$router.replace({ name: 'dashboard' });
      }
    },
    // TODO: 로그인 후 로컬스토리지에 토큰을 저장합니다.
    // logon(){ /* 로그인 처리 로직 */ }
    async submit() {
      // 아이디 또는 패스워드를 입력하지 않았을 때 그에 맞게 포커싱을 해줘야 한다.
      // 1. 아이디 입력과 패스워드 입력 중 빈값을 찾아내야 한다.
      //
      if (this.username === '' || this.password === '') {
        if (this.username === '') {
          this.$refs.cursor.focus();
          // alert("아이디입력")
        } else {
          this.$refs.cursor1.focus();
          // alert("패스워드 입력")
        }
        //   this.errmessage = true;
        return;
      }
      //공백이 포함된경우 에러메시지 출력
      if (this.username.includes(' ')) {
        this.loginErrorMsg =
          this.$t('login.userIdHasSpace');
        return;
      }
      if (this.password.includes(' ')) {
        this.loginErrorMsg =
          this.$t('login.passwordHasSpace');
        return;
      }

      const isValidate = this.$refs.observer.validate();

      // validation이 되었다면
      if (isValidate) {
        this.clearLoginError();
        this.loginErrorMsg = undefined;
        const res = await authLogin({
          username: this.username,
          password: this.password
        });

        if (res) {
          await this.redirectToDashboard();
        }
      } else {
        // input error handling
        this.loginErrorMsg =
          this.$t('login.invalidInput');
      }
    },
    clear() {
      this.username = '';
      this.password = '';
      this.autoLogin = null;
    },
    ...mapActions({ clearLoginError: 'user/clearLoginError' }),
    ...mapActions({ resetState: 'explorer/resetState' }),
    ...mapActions({ resetAiDefectViewState: 'dashboard/resetAiDefectViewState' })
  }
};
</script>

<style scoped>
.v-main {
  background: url("/img/login_background.jpg") no-repeat center fixed;
  filter: brightness(0.95);
  background-size: cover;
}

.errmsg {
  text-align: center;
  /* margin-left: 120px; */
  color: red;
  font-weight: normal!important;
  margin-bottom: 0;
}
.login-page {
  /*background-image: url("../../assets/image/smart-city2.jpg");*/
  /*background-image: url("../../assets/image/smart-city.jpg");*/
  background-repeat: no-repeat;
  background-size: 100%;
  overflow-y: visible;
}

.elevation-12 {
  box-sizing: border-box;
  position: absolute;
  width: 520px;
  height: 680px;
  left: calc(50% - 520px / 2);
  top: calc(50% - 600px / 2 - 0.5px);
  background: rgba(217, 217, 217, 0.1);
  box-shadow: 0 4px 80px rgba(0, 0, 0, 0.3);
  opacity: 80;
  margin: auto;
  align-items: center;
  min-width: none;
  margin-top: -50px;
  /* border-color: transparent!important; */
}
.Drone_image {
  width: 1940px;
  height: 900px;
}
.drone_font {
  font-size: 30px;
  color: #dce6f2;
  display: inline-block;
  position: absolute;
  width: 550px;
  height: 524px;
  top: 330px;
  left: 200px;
  font-family: cursive;
  font-style: normal;
  margin: auto;
}
.drone_font1 {
  font-size: 20px;
  color: #dce6f2;
  display: inline-block;
  position: absolute;
  width: 550px;
  height: 524px;
  top: 340px;
  left: 314px;
  font-family: cursive;
  font-style: normal;
  margin: auto;
}
.drone_font2 {
  font-size: 30px;
  color: #dce6f2;
  display: inline-block;
  position: absolute;
  width: 550px;
  height: 524px;
  top: 330px;
  left: 340px;
  font-family: cursive;
  font-style: normal;
  margin: auto;
}

.solar_font {
  font-size: 40px;
  color: #3969c2;
  display: inline-block;
  position: absolute;
  width: 500px;
  height: 524px;
  top: 360px;
  left: 200px;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  font-style: normal;
  font-weight: bold;
  margin: auto;
}

.metarpas_font {
  font-size: 20px;
  color: #13708f;
  display: inline-block;
  position: absolute;
  width: 400px;
  height: 524px;
  top: 420px;
  left: 400px;
  font-family: "Inter";
  font-style: normal;
  margin: auto;
}
.logo_image {
  margin-top: 30px;
  width: 380px;
  align-items: center;
  margin-left: 70px;
}

.inputbox {
  position: relative;
  /* margin: 10px 0; */
  top: -10px;
  left: 25px;
}

/*
 * 로그인 배경이 밝음: 앱 전역이 다크여도 입력·라벨·아이콘은 검정 계열로 고정
 * (디자인/레이아웃은 기본 v-text-field 유지)
 */
.login-page ::v-deep .inputbox .v-text-field .v-label {
  color: rgba(0, 0, 0, 0.87) !important;
}

.login-page ::v-deep .inputbox .v-text-field.v-input--is-focused .v-label,
.login-page ::v-deep .inputbox .v-text-field .v-label--active {
  color: rgba(0, 0, 0, 0.87) !important;
}

.login-page ::v-deep .inputbox .v-text-field input {
  color: #000 !important;
  caret-color: #000 !important;
}

.login-page ::v-deep .inputbox .v-text-field .v-icon {
  color: rgba(0, 0, 0, 0.7) !important;
}

.login-page ::v-deep .inputbox .v-text-field > .v-input__control > .v-input__slot::before,
.login-page ::v-deep .inputbox .v-text-field > .v-input__control > .v-input__slot::after {
  background-color: rgba(0, 0, 0, 0.42) !important;
  border-color: rgba(0, 0, 0, 0.42) !important;
}

.login-page ::v-deep .inputbox .v-text-field.v-input--is-focused > .v-input__control > .v-input__slot::after {
  background-color: rgba(0, 0, 0, 0.87) !important;
}

.login-page ::v-deep .inputbox .v-text-field .v-messages {
  color: #c62828 !important;
}

/* 로그인 전용: 앱 라이트/다크 테마와 무관하게 고정 (배경이 항상 동일) */
.login_btn.v-btn {
  background-color: cadetblue !important;
  border: none !important;
  box-shadow: none !important;
  color: #000 !important;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  border-radius: 10px;
  top: 30px;
  left: 60px;
  position: relative;
  transition: opacity 0.15s ease;
}

.login_btn.v-btn .v-btn__content {
  color: #000 !important;
}

/* hover: 색 전환 대신 흔한 패턴인 살짝 투명도만 조정 */
.login_btn.v-btn:hover {
  opacity: 0.88;
}

.login_btn.v-btn:focus-visible {
  opacity: 0.88;
}

.dcncaoper_img {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-right: 230px !important;
  margin-bottom: 350px !important;
}

@media screen and (max-width: 1800px) {
  .main_font {
    display: none;
  }
  .dcncaoper_img {
    display: none;
  }
}
</style>
